"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ReservationRequest;
(function (ReservationRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.initialDate = undefined;
            _this.expirationDate = undefined;
            _this.status = undefined;
            _this.itemsReservation = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    ReservationRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.initialDate = undefined;
            _this.expirationDate = undefined;
            _this.status = undefined;
            _this.itemsReservation = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    ReservationRequest.Update = Update;
})(ReservationRequest = exports.ReservationRequest || (exports.ReservationRequest = {}));
var ReservationResponse;
(function (ReservationResponse) {
    var Reservation = (function (_super) {
        __extends(Reservation, _super);
        function Reservation() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.initialDate = undefined;
            _this.expirationDate = undefined;
            _this.status = undefined;
            _this.itemsReservationDetail = undefined;
            _this.user = undefined;
            return _this;
        }
        return Reservation;
    }(BaseModel_1["default"]));
    ReservationResponse.Reservation = Reservation;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    ReservationResponse.All = All;
})(ReservationResponse = exports.ReservationResponse || (exports.ReservationResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/reservation.js
// module id = ../model/dist/models/reservation.js
// module chunks = main